export function TopNavButtons({ handleSignOut, openChangeListModal }) {
  return (
    <div style={{ display: "flex", justifyContent: "flex-end", gap: "1rem" }}>
      <button onClick={handleSignOut}>Ausloggen</button>
      <button onClick={openChangeListModal}>Liste wechseln</button>
    </div>
  );
}
